import * as yup from 'yup';
import { EExtendedFieldTypes, EFormFieldsNames } from '../../../types/requestForm';
export var MESSAGE_FIELD = {
  field: {
    label: 'Расскажите, с чем нужна помощь',
    description: 'Добавьте картинку, если нужно',
    name: EFormFieldsNames.Message,
    type: EExtendedFieldTypes.TextAreaField,
    required: true,
    textArea: {
      height: 'medium',
      resize: 'vertical'
    }
  },
  validation: yup.string().required('Введите текст сообщения')
};